export default __webpack_public_path__ + "static/stock-family-edda59ac8461bd0cda7418a769effa72.jpeg";